export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  requiredPermissions?: string[]
  requiresAdminGroup?: boolean
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
      requiredPermissions: ['dashboard.view'],
    },
    {
      name: 'system-adc',
      displayName: 'ADC',
      meta: { icon: 'rule_book' },
      requiresAdminGroup: true,
    },
    {
      name: 'system-permissions',
      displayName: 'Roles',
      meta: {
        icon: 'admin_panel_settings',
      },
      requiresAdminGroup: true,
    },
    {
      name: 'system-users',
      displayName: 'Users',
      meta: {
        icon: 'manage_accounts',
      },
      requiresAdminGroup: true,
    },
    {
      name: 'projects',
      displayName: 'menu.projects',
      meta: {
        icon: 'folder_shared',
      },
      requiredPermissions: ['project.view'],
    },
    {
      name: 'users',
      displayName: 'Users',
      meta: {
        icon: 'groups',
      },
      requiredPermissions: ['user.view'],
    },
    {
      name: 'permissions',
      displayName: 'Permissions',
      meta: {
        icon: 'security',
      },
      requiredPermissions: ['permission.view'],
    },
    {
      name: 'secrets',
      displayName: 'Secrets',
      meta: {
        icon: 'vpn_key',
      },
      requiredPermissions: ['secret.view'],
    },
    {
      name: 'operations-ai-first',
      displayName: 'AI First',
      meta: {
        icon: 'psychology',
      },
      requiredPermissions: ['project.view'],
    },
    {
      name: 'operations-graph',
      displayName: 'Graphs',
      meta: {
        icon: 'account_tree',
      },
      requiredPermissions: ['project.view'],
    },
    {
      name: 'security-guardian',
      displayName: 'Guardian',
      meta: {
        icon: 'security',
      },
      requiresAdminGroup: true,
    },
    {
      name: 'support-desk',
      displayName: 'Desk',
      meta: {
        icon: 'support_agent',
      },
      requiredPermissions: ['support.chat.view', 'support.ticket.view'],
    },
    {
      name: 'support-chat',
      displayName: 'Chat',
      meta: {
        icon: 'forum',
      },
      requiredPermissions: ['support.chat.view'],
    },
    {
      name: 'support-tickets',
      displayName: 'Tickets',
      meta: {
        icon: 'confirmation_number',
      },
      requiredPermissions: ['support.ticket.view'],
    },
    {
      name: 'support-schedule',
      displayName: 'Schedule',
      meta: {
        icon: 'schedule',
      },
      requiredPermissions: ['support.settings.manage'],
    },
    {
      name: 'backup',
      displayName: 'Backups',
      meta: {
        icon: 'backup',
      },
      requiresAdminGroup: true,
    },
    {
      name: 'system-settings',
      displayName: 'Settings',
      meta: {
        icon: 'settings',
      },
      requiredPermissions: ['project.view'],
    },
  ] as INavigationRoute[],
}
